import * as React from "react"

import { cn } from "@/lib/utils"

/** A row of mutually exclusive choices, styled as the report's tabs. */
export function Segmented({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}): JSX.Element {
  return (
    <div
      role="group"
      aria-label={label}
      className="inline-flex items-center gap-0.5 rounded-lg border border-border bg-surface-sunken p-1"
    >
      {children}
    </div>
  )
}

export function SegmentButton({
  pressed,
  onClick,
  children,
}: {
  pressed: boolean
  onClick: () => void
  children: React.ReactNode
}): JSX.Element {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      onClick={onClick}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-caption font-medium transition-colors duration-120",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--brand)]",
        pressed ? "bg-surface text-text shadow-e1" : "text-text-3 hover:text-text",
      )}
    >
      {children}
    </button>
  )
}
